import { Trophy, TrendingUp } from "lucide-react"
import { colors } from "../../styles/theme"

interface TournamentTabsProps {
  activeTab: "brackets" | "leaderboard"
  onTabChange: (tab: "brackets" | "leaderboard") => void
}

export function TournamentTabs({ activeTab, onTabChange }: TournamentTabsProps) {
  return (
    <div className="border-b" style={{ borderColor: colors.border.primary }}>
      <nav className="flex">
        <button
          onClick={() => onTabChange("brackets")}
          className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
            activeTab === "brackets" ? "" : "border-transparent hover:border-gray-600"
          }`}
          style={
            activeTab === "brackets"
              ? { borderColor: colors.primary[500], color: colors.primary[500] }
              : { color: colors.text.secondary }
          }
        >
          <div className="flex items-center gap-2">
            <Trophy className="h-4 w-4" />
            Elimination Brackets
          </div>
        </button>
        <button
          onClick={() => onTabChange("leaderboard")}
          className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
            activeTab === "leaderboard" ? "" : "border-transparent hover:border-gray-600"
          }`}
          style={
            activeTab === "leaderboard"
              ? { borderColor: colors.primary[500], color: colors.primary[500] }
              : { color: colors.text.secondary }
          }
        >
          <div className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Ladder Points
          </div>
        </button>
      </nav>
    </div>
  )
} 